/**
 * Blog Posts Index
 * 
 * This file defines the available blog posts.
 * Posts are loaded from .md files in the /public/posts directory using fetch().
 * 
 * To add a new post:
 * 1. Create a .md file in public/posts/
 * 2. Add the filename (without extension) to the postIds array below
 */

// List of available post IDs (matches the filename without .md)
export const postIds = [
  'ide-creation-patterns',
  'pub-sub-singleton-config',
];

/**
 * Load a post by ID
 * Fetches the .md file from the /posts directory (in public folder)
 */
export const loadPostContent = async (id) => {
  try {
    // Fetch the markdown file from public/posts
    const response = await fetch(`/posts/${id}.md`);
    if (!response.ok) {
      throw new Error(`Failed to load post: ${response.statusText}`);
    }
    const content = await response.text();
    return content;
  } catch (error) {
    console.error(`Error loading post ${id}:`, error);
    return null;
  }
};

/**
 * Load all posts
 */
export const loadAllPosts = async () => {
  const posts = [];
  
  for (const id of postIds) {
    const content = await loadPostContent(id);
    if (content) {
      posts.push({ id, content });
    }
  }
  
  return posts;
};

/**
 * Get all post IDs
 */
export const getAllPostIds = () => [...postIds];

const postsApi = { postIds, loadPostContent, loadAllPosts, getAllPostIds };
export default postsApi;
